// Package Imports
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const HoldUnholdResource: ResourceItem = {
  name: resourceName.holdRelease,
  identifier: ModuleIdentifierConst.HOLD_RELEASE_VIEW,
  meta: {
    label: 'Hold/Release',
  },
};

export default HoldUnholdResource;
